import { render } from "./SmallCart.vue?vue&type=template&id=2ebde1d1&lang=pug"
import script from "./SmallCart.vue?vue&type=script&lang=js"
export * from "./SmallCart.vue?vue&type=script&lang=js"

import "./SmallCart.vue?vue&type=style&index=0&id=2ebde1d1&lang=sass"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QSeparator,QScrollArea});
